import { useRequestEvent, useRuntimeConfig } from "#imports";
import { DEFAULT_MARKET } from "../../config.js";
import { getRequestCountryCode } from "../../server/getRequestCountryCode.js";
import { createMarketplace } from "../utils/createMarketplace.js";
import { getMarketFromDomain } from "../utils/getMarketFromDomain.js";
import { useMarkets } from "./useMarkets.js";
export function useMarketplace(countryCode) {
  const event = useRequestEvent();
  const allMarkets = useMarkets();
  const config = useRuntimeConfig(event).public.marketplace;
  const resolvedCountryCode = resolveCountryCode(countryCode, event);
  const market = allMarkets[resolvedCountryCode];
  const marketplace = createMarketplace(market, allMarkets);
  return {
    allMarkets,
    market,
    marketplace,
    features: config.features[resolvedCountryCode]
  };
}
function resolveCountryCode(countryCode, event) {
  if (countryCode) {
    return countryCode;
  }
  if (event) {
    return getRequestCountryCode(event);
  }
  if (typeof window !== "undefined") {
    return getMarketFromDomain(window.location.origin).countryCode;
  }
  return DEFAULT_MARKET.countryCode;
}
